const LINE_LENGTH = 25;
const ARROW_HEAD_SIZE = 8;
const ARROW_LINE_WIDTH = 5;

export const drawCircle = (context, xPos, yPos, color) => {
    context.save();
    context.beginPath();

    context.fillStyle = color;
    
    context.arc(xPos, yPos, 7, 0, 2 * Math.PI);

    context.closePath();
    context.fill();
    context.restore();
}

export const drawArrow = (context, fromXPos, fromYPos, toXPos, toYPos, color) => {
    context.save();
    context.beginPath();

    context.strokeStyle = color;
    context.fillStyle = color;
    context.lineWidth = ARROW_LINE_WIDTH;

    // Draw a line
    
    context.moveTo(fromXPos, fromYPos);
    context.lineTo(toXPos, toYPos);
    context.stroke();

    // Draw a arrow head triangle
    const radian = Math.atan((toYPos - fromYPos) / (toXPos - fromXPos)) + ((toXPos >= fromXPos ? 90 : -90) * Math.PI / 180);
    context.translate(toXPos, toYPos);
    context.rotate(radian);
    context.moveTo(0, -ARROW_HEAD_SIZE);
    context.lineTo(ARROW_HEAD_SIZE, ARROW_HEAD_SIZE);
    context.lineTo(-ARROW_HEAD_SIZE, ARROW_HEAD_SIZE);

    context.closePath();
    context.fill();
    context.restore();
};

export const drawArrowByAngle = (context, fromXPos, fromYPos, angle, color) => {
    const angleInRadians = (angle - 90) * Math.PI / 180;
    const toXPos = fromXPos + LINE_LENGTH * Math.cos(angleInRadians);
    const toYPos = fromYPos + LINE_LENGTH * Math.sin(angleInRadians);
    drawArrow(context, fromXPos, fromYPos, toXPos, toYPos, color);
};
